export const tabs = [
  { value: "responsible", title: "Responsible" },
  { value: "raised", title: "Raised" },
];

export const priorityOptions = [
  { label: "Low", value: "LOW" },
  { label: "Medium", value: "MEDIUM" },
  { label: "High", value: "HIGH" },
  { label: "Urgent", value: "URGENT" },
  { label: "Emergency", value: "EMERGENCY" },
];